module.exports = __webpack_public_path__ + "images/emoji/100.14ef1567fcb7b59de5e5.png";